
const adobeAnalyticsImplementationQ = {
    topic: 'Adobe Analytics',
    questions: [
        {
            question: "What is Adobe Launch?",
            choices: [
                "A cloud-based photo editing tool",
                "A website hosting service",
                "A tag management system",
                "An SEO optimization tool"
            ],
            correctAnswer: "A tag management system"
        },
        {
            question: "What is the primary purpose of using Adobe Launch for Adobe Analytics implementation?",
            choices: [
                "To create marketing emails",
                "To manage and deploy analytics and marketing tags",
                "To design website layouts",
                "To write JavaScript code from scratch"
            ],
            correctAnswer: "To manage and deploy analytics and marketing tags"
        },
        {
            question: "In Adobe Launch, what is a 'rule'?",
            choices: [
                "A set of conditions and actions that define when and what to do when a specific event occurs",
                "A guideline for writing code",
                "A built-in function for testing website speed",
                "A template for creating reports"
            ],
            correctAnswer: "A set of conditions and actions that define when and what to do when a specific event occurs"
        },
        {
            question: "How do you add the Adobe Analytics extension to Adobe Launch?",
            choices: [
                "By copying the code from Adobe Analytics and pasting it into Adobe Launch",
                "By selecting and installing the Adobe Analytics extension from the Extensions Catalog in Adobe Launch",
                "By writing a custom JavaScript plugin",
                "By uploading a CSV file with the extension details"
            ],
            correctAnser: "By selecting and installing the Adobe Analytics extension from the Extensions Catalog in Adobe Launch"
        },
        {
            question: "What is the purpose of a data element in Adobe Launch?",
            choices: [
                "To store CSS styles",
                "To define and store values from your website to be used in rules and extensions",
                "To manage user permissions",
                "To create dynamic images"
            ],
            correctAnswer: "To define and store values from your website to be used in rules and extensions"
        },
        {
            question: "Which of the following is a correct sequence for setting up Adobe Analytics tracking using Adobe Launch?",
            choices: [
                "Create rules, configure the Adobe Analytics extension, publish to the library",
                "Configure the Adobe Analytics extension, create data elements, create rules, publish to the library",
                "Publish to the library, configure the Adobe Analytics extension, create rules",
                "Create data elements, publish to the library, create rules"
            ],
            correctAnswer: "Configure the Adobe Analytics extension, create data elements, create rules, publish to the library"
        },
        {
            question: "What is the purpose of the Adobe Analytics extension's 'Global Variables' section in Adobe Launch?",
            choices: [
                "To set up global JavaScript functions",
                "To configure global Adobe Analytics report suite IDs and eVars, props, and events",
                "To store images and media files",
                "To manage user roles and permissions"
            ],
            correctAnswer: "To configure global Adobe Analytics report suite IDs and eVars, props, and events"
        },
        {
            question: "How can you debug and test Adobe Analytics implementations using Adobe Launch?",
            choices: [
                "By using the Network tab in browser developer tools",
                "By using the Adobe Analytics Debugger tool",
                "By checking the browser console for error messages",
                "All of the above"
            ],
            correctAnswer: "All of the above"
        },
        {
            question: "Which of the following methods can be used to deploy changes in Adobe Launch to a production environment?",
            choices: [
                "By publishing the library to the production environment",
                "By exporting the code and manually uploading it to the server",
                "By sending an email request to Adobe Support",
                "By using the built-in FTP upload feature in Adobe Launch"
            ],
            correctAnswer: "By publishing the library to the production environment"
        },
        {
            question: "If you need to track a custom event such as a form submission, what steps should you follow in Adobe Launch?",
            choices: [
                "Create a rule that listens for the form submission event, then use the Adobe Analytics extension action to send the event data",
                "Manually edit the HTML of the form to include Adobe Analytics tracking code",
                "Use a pre-built template for form tracking",
                "None of the above"
            ],
            correctAnswers: "Create a rule that listens for the form submission event, then use the Adobe Analytics extension action to send the event data"
        },
        {
            question: "What is the best practice for managing multiple environments (e.g., development, staging, production) in Adobe Launch?",
            choices: [
                "Using different Launch properties for each environment",
                "Using environment-specific libraries and deploying each library to its respective environment",
                "Configuring a single Launch property and changing the environment settings manually",
                "Using a third-party tool to manage environments"
            ],
            correctAnswer: "Using environment-specific libraries and deploying each library to its respective environment"
        },
        {
            question: "How can you ensure that the data collected by Adobe Analytics via Adobe Launch is accurate and complete?",
            choices: [
                "Regularly reviewing and testing the implementation",
                "Using data validation tools and automated testing scripts",
                "Conducting periodic audits and monitoring data discrepancies",
                "All of the above"
            ],
            correctAnswer: "All of the above"
        },
        {
            question: "What key sections should be included in a Technical Specifications Document (TSD) for an Adobe Analytics implementation?",
            choices: [
                "Project Overview, Goals and Objectives, Metrics and KPIs, Data Layer Specifications, Tracking Requirements, Implementation Details, Testing Plan, and Data Validation",
                "Project Overview, Design Mockups, Content Strategy, Social Media Plan, and Budget",
                "SEO Strategy, Marketing Emails, Web Hosting Details, and Graphic Design Assets",
                "User Manuals, HR Policies, Budget Reports, and Training Materials",
                "Skip Question"
            ],
            correctAnswer: "Project Overview, Goals and Objectives, Metrics and KPIs, Data Layer Specifications, Tracking Requirements, Implementation Details, Testing Plan, and Data Validation"
        },
        {
            question: "When documenting data layer specifications in a TSD, which information is crucial to include?",
            choices: [
                "Data Layer Object structure, variable names, data types, descriptions, and example values",
                "Project budget, timeline, and stakeholder names",
                "User feedback, design preferences, and color schemes",
                "Server configuration, network settings, and database schemas",
                "Skip Question"
            ],
            correctAnswer: "Data Layer Object structure, variable names, data types, descriptions, and example values"
        },
        {
            question: "How do you document custom events in a TSD for Adobe Analytics using Adobe Launch?",
            choices: [
                "By describing the event, specifying the event name, data layer variables involved, and the conditions under which the event is triggered",
                "By listing all possible HTML tags that can trigger the event",
                "By providing a brief overview of the event without technical details",
                "By including screenshots of the website's HTML code",
                "Skip Question"
            ],
            correctAnswer: "By describing the event, specifying the event name, data layer variables involved, and the conditions under which the event is triggered"
        },
        {
            question: "Which of the following best describes how to detail variable mapping in a TSD for Adobe Analytics?",
            choices: [
                "Listing each Adobe Analytics variable (eVar, prop, event), its corresponding data layer variable, description, and purpose",
                "Creating a visual diagram of the website's layout",
                "Writing a narrative description of the website's user journey",
                "Including a list of all JavaScript functions used on the site",
                "Skip Question"
            ],
            correctAnswer: "Listing each Adobe Analytics variable (eVar, prop, event), its corresponding data layer variable, description, and purpose"
        },
        {
            question: "What information is typically included in the 'Testing Plan' section of a TSD?",
            choices: [
                "Specific test cases, expected results, testing methods, tools used, and responsible personnel",
                "User feedback summaries, design preferences, and content strategy",
                "Marketing objectives, target audience demographics, and advertising channels",
                "Budget allocation, project timelines, and team roles",
                "Skip Question"
            ],
            correctAnswer: "Specific test cases, expected results, testing methods, tools used, and responsible personnel"
        },
        {
            question: "How would you document an implementation detail for tracking a form submission in a TSD?",
            choices: [
                "Provide the form ID, the specific data layer variables to capture (e.g., form name, input values), and the rule configuration in Adobe Launch",
                "Describe the visual design of the form and user experience flow",
                "List all potential error messages that the form might generate",
                "Include a marketing strategy for forms on the website",
                "Skip Question"
            ],
            correctAnswer: "Provide the form ID, the specific data layer variables to capture (e.g., form name, input values), and the rule configuration in Adobe Launch"
        },
        {
            question: "Which practices should be followed when writing a TSD to ensure it is useful for both developers and analysts?",
            choices: [
                "Using clear, concise language; including diagrams and examples; ensuring thorough documentation of variables and events; and providing testing and validation steps",
                "Writing long, detailed paragraphs without technical jargon",
                "Including only high-level overviews without specific details",
                "Focusing solely on the design aspects and ignoring technical details",
                "Skip Question"
            ],
            correctAnswer: "Using clear, concise language; including diagrams and examples; ensuring thorough documentation of variables and events; and providing testing and validation steps"
        },
        {
            question: "How should data validation and discrepancy resolution be documented in a TSD?",
            choices: [
                "By describing the validation process, listing the tools used, specifying the frequency of validation, and outlining the steps to resolve data discrepancies",
                "By summarizing the project's financial budget and resource allocation",
                "By documenting user feedback and satisfaction surveys",
                "By providing a high-level overview of the project's timeline and milestones",
                "Skip Question"
            ],
            correctAnswer: "By describing the validation process, listing the tools used, specifying the frequency of validation, and outlining the steps to resolve data discrepancies"
        }
    ]
};

export default adobeAnalyticsImplementationQ;
